function refreshHorizonCart() {
  import('@theme/events').then(({ CartUpdateEvent }) => {
    const cartDrawer = document.querySelector('cart-drawer');    
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const event = new CartUpdateEvent(cart, 'manual-trigger', {
          itemCount: cart.item_count,
          source: 'manual-refresh',
          sections: {}
        });
        document.dispatchEvent(event);

        if (cartDrawer?.hasAttribute('auto-open')) {
          cartDrawer.open();
        }
      });
  });
}

document.addEventListener('cart:refresh', refreshHorizonCart);
